<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">招标情况填录（开标结果）</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <invite-result
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></invite-result>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="996"
              ></attachments>
            </el-form-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目开标结果</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import InviteResult from "@/page/form/inviteResult";

import ObjectUtil from "../mixins/objectUtil";
export default {
  mixins: [ObjectUtil],
  components: {
    InviteResult,
    Attachments,
  },
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        relateId: "",
        kbsj: "",
        type: 0,
        xfz: "",
        zbdw: "",
        zbj: "",
      },
      hasSetup: false,
      attachmentArr: [],
      formLoading: false,
    };
  },
  mounted() {
    this.form.relateId = this.$route.params.relateId;
    this.getProject();
    this.getSetupDetail();
  },
  methods: {
    // 获取历史立项信息
    getSetupDetail() {
      this.formLoading = true;
      ajax.get(
        "/contract/invite/situation/info/",
        {
          relateId: this.form.relateId,
          type: this.form.type,
        },
        (res) => {
          if (res.vo) {
            this.hasSetup = true;
            this.form.kbsj = res.vo.kbsj;
            this.form.xfz = res.vo.xfz;
            this.form.zbdw = res.vo.zbdw;
            this.form.zbj = res.vo.zbj;
            this.attachmentArr = res.vo.attachments ? res.vo.attachments : [];
          }
          this.formLoading = false;
        }
      );
    },
    // 获取项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.relateId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交项目申请
    createProject() {
      this.form.attachments = this.$refs.attachments.getAttachments();
      console.log(this.form);

      this.formLoading = true;
      let _url = !this.hasSetup
        ? "/contract/invite/situation/add"
        : "/contract/invite/situation/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success("提交项目开标结果成功");
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/inviteResult.vue